import axios from 'axios';
import { extractWishlistProductIds } from './wishlist-utils';

export async function fetchWishlistProductIds(userId, token) {
  try {
    const response = await axios.post(
      `user/wishlist/${userId}`,
      { count: { start: 0, limit: 500 } },
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.data.status) {
      return extractWishlistProductIds(response.data.data.wishlist);
    }
  } catch (error) {
    // Empty wishlist returns status false — treat as no items.
  }

  return [];
}
